import { fetcher, fetcherDelete, fetcherPost } from '../utils/axios';

export const addSongToPlaylist = (playlistId, songId) =>
  fetcherPost([`/playlist/${encodeURIComponent(playlistId)}/songs`, { songId }]);

export const addSongsToPlaylist = (playlistId, songIds) =>
  fetcherPost([`/playlist/${encodeURIComponent(playlistId)}/songs`, { songIds }]);

export const getPlaylistCustomerIds = (playlistId) =>
  fetcher(`/playlist/${encodeURIComponent(playlistId)}/customers`);

export const assignPlaylistToCustomer = (playlistId, customerId) =>
  fetcherPost([`/playlists/customer/${encodeURIComponent(customerId)}`, { playlists: [playlistId] }]);

export const removePlaylistFromCustomer = (playlistId, customerId) =>
  fetcherDelete([`/playlists/customer/${encodeURIComponent(customerId)}`, { data: { playlists: [playlistId] } }]);
